const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'group-notifiction');
const Form = resolve => require.ensure([], () => resolve(require('./Form.vue')), 'group-notifiction');

export default [{
  path: '/admin/notifications',
  name: 'admin/notifications',
  component: Index,
  meta: {
    title: '通知管理',
    layout: 'admin',
  },
}, {
  path: '/admin/notifications/new',
  name: 'admin/notifications/new',
  component: Form,
  meta: {
    title: '新建通知',
    layout: 'admin',
  },
}, {
  path: '/admin/notifications/:id/edit',
  name: 'admin/notifications/edit',
  component: Form,
  meta: {
    title: '更新通知',
    layout: 'admin',
  },
}];



// WEBPACK FOOTER //
// ./src/pages/admin/notifiction/index.js